import React from "react";

import IndicatorDashboard from "./IndicatorDashboard";
import {
  fetchLifeQuality,
  fetchLifeQualityRegion,
} from "../../services/infrastructure";

export default function LifeQuality(props) {
  return (
    <IndicatorDashboard
      {...props}
      fetchAggregate={fetchLifeQuality}
      fetchRegion={fetchLifeQualityRegion}
      pairedIds={[11, 12, 13]}
      singleIds={[]}
      sectionTitleKey="infrastructure.lifeQualitySection"
    />
  );
}
